export default __webpack_public_path__ + "static/media/next.8b18acdd.svg";